<div *ngIf="type === 'circle'"><i class="bx bx-loader-alt bx-spin"></i></div>
<ng-container *ngIf="type === 'row'">
	<p class="content-placeholder" *ngFor="let number of numbers; index as i; trackBy: trackByFn" [ngClass]="{ 'mb-a': numbers.length-1 === i  }">
	</p>
</ng-container>